import { setSearchTerm } from "../attributeDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useAttributeSearch = () => useSearch(s => s.data.listing.attributes.searchTerm, setSearchTerm);
